// @ts-nocheck

import { type ObjectValuesUnionType } from '../utils/typing';

export const GeneralSpineAnimationsIds = Object.freeze({
  WIN_FREEBETS: 'WIN_FREEBETS',
});

const KLSpineAnimationIds = Object.freeze({
  KL_INTRO: 'KOH_LANTA:INTRO',
  KL_BADGE_WON_FISHING: 'KOH_LANTA:BADGE_WON:FISHING',
  KL_BADGE_LOST_FISHING: 'KOH_LANTA:BADGE_LOST:FISHING',
  KL_BADGE_WON_FIRECAMP: 'KOH_LANTA:BADGE_WON:FIRECAMP',
  KL_BADGE_LOST_FIRECAMP: 'KOH_LANTA:BADGE_LOST:FIRECAMP',
  KL_BADGE_WON_HUT: 'KOH_LANTA:BADGE_WON:HUT',
  KL_BADGE_LOST_HUT: 'KOH_LANTA:BADGE_LOST:HUT',
  KL_BADGE_WON_RICE: 'KOH_LANTA:BADGE_WON:RICE',
  KL_BADGE_LOST_RICE: 'KOH_LANTA:BADGE_LOST:RICE',
  KL_BADGE_WON_WATER: 'KOH_LANTA:BADGE_WON:WATER',
  KL_BADGE_LOST_WATER: 'KOH_LANTA:BADGE_LOST:WATER',
  KL_BADGE_WON_BALANCE: 'KOH_LANTA:BADGE_WON:BALANCE',
  KL_BADGE_LOST_BALANCE: 'KOH_LANTA:BADGE_LOST:BALANCE',
  KL_BADGE_WON_GRAND_BLUE: 'KOH_LANTA:BADGE_WON:GRAND_BLUE',
  KL_BADGE_LOST_GRAND_BLUE: 'KOH_LANTA:BADGE_LOST:GRAND_BLUE',
  KL_BADGE_WON_DUO: 'KOH_LANTA:BADGE_WON:DUO',
  KL_BADGE_LOST_DUO: 'KOH_LANTA:BADGE_LOST:DUO',
  KL_BADGE_WON_SLOTH: 'KOH_LANTA:BADGE_WON:SLOTH',
  KL_BADGE_LOST_SLOTH: 'KOH_LANTA:BADGE_LOST:SLOTH',
  KL_BADGE_WON_BAMBOOS: 'KOH_LANTA:BADGE_WON:BAMBOOS',
  KL_BADGE_LOST_BAMBOOS: 'KOH_LANTA:BADGE_LOST:BAMBOOS',
  KL_COMFORT_WON_CHOCOLATE: 'KOH_LANTA:COMFORT_WON:CHOCOLATE',
  KL_COMFORT_LOST_CHOCOLATE: 'KOH_LANTA:COMFORT_LOST:CHOCOLATE',
  KL_COMFORT_WON_HOTEL: 'KOH_LANTA:COMFORT_WON:HOTEL',
  KL_COMFORT_LOST_HOTEL: 'KOH_LANTA:COMFORT_LOST:HOTEL',
  KL_COMFORT_WON_PIZZA: 'KOH_LANTA:COMFORT_WON:PIZZA',
  KL_COMFORT_LOST_PIZZA: 'KOH_LANTA:COMFORT_LOST:PIZZA',
  KL_COLLAR_WON: 'KOH_LANTA:COLLAR_WON',
  KL_COLLAR_LOST: 'KOH_LANTA:COLLAR_LOST',
  KL_VICTORY: 'KOH_LANTA:VICTORY',
  KL_VOTE: 'KOH_LANTA:VOTE',
  KL_COLLAR_USED: 'KOH-LANTA:COLLAR_USED',
  KL_TORCH: 'KOH_LANTA:TORCH',
  KL_ROUND_COMPLETE: 'KOH_LANTA:ROUND_COMPLETE',
  KL_MARK_WON_1: 'KOH_LANTA:MARK_WON:1',
  KL_MARK_LOST_1: 'KOH_LANTA:MARK_LOST:1',
  KL_MARK_WON_2: 'KOH_LANTA:MARK_WON:2',
  KL_MARK_LOST_2: 'KOH_LANTA:MARK_LOST:2',
  KL_MARK_WON_3: 'KOH_LANTA:MARK_WON:3',
  KL_MARK_LOST_3: 'KOH_LANTA:MARK_LOST:3',
  KL_TAG_WON_1: 'KOH_LANTA:TAG_WON:1',
  KL_TAG_LOST_1: 'KOH_LANTA:TAG_LOST:1',
  KL_TAG_WON_2: 'KOH_LANTA:TAG_WON:2',
  KL_TAG_LOST_2: 'KOH_LANTA:TAG_LOST:2',
  KL_TAG_WON_3: 'KOH_LANTA:TAG_WON:3',
  KL_TAG_LOST_3: 'KOH_LANTA:TAG_LOST:3',
  KL_KNIFE_WON: 'KOH_LANTA:KNIFE_WON',
  KL_KNIFE_LOST: 'KOH_LANTA:KNIFE_LOST',
  KL_KNIFE_MISS_1: 'KOH_LANTA:KNIFE_MISS:1',
  KL_KNIFE_MISS_2: 'KOH_LANTA:KNIFE_MISS:2',
  KL_KNIFE_MISS_3: 'KOH_LANTA:KNIFE_MISS:3',
  KL_POLE_BET_WON: 'KOH_LANTA:POLE_BET_WON',
  KL_POLE_BET_LOST: 'KOH_LANTA:POLE_BET_LOST',
});

export const BetBuilderSpineAnimationIds = Object.freeze({
  MY_MATCH: 'MY_MATCH',
});

export const WinModalSpineAnimationIds = Object.freeze({
  WM_SOLDAT: 'WM:SOLDAT',
  WM_BASKET: 'WM:BASKET',
  WM_BOXEUR: 'WM:BOXEUR',
  WM_COSMO: 'WM:COSMO',
  WM_CROCO: 'WM:CROCO',
  WM_GENIE: 'WM:GENIE',
  WM_GORILLE: 'WM:GORILLE',
  WM_HALTEROPHILE: 'WM:HALTEROPHILE',
  WM_LION: 'WM:LION',
  WM_SAGE: 'WM:SAGE',
  WM_SUPERMAN: 'WM:SUPERMAN',
});

export const BetShareSpineAnimationIds = Object.freeze({
  BS_WIN: 'BS:WIN',
  BS_CANCEL: 'BS:CANCEL',
});

export const OverlaySpineAnimationsIds = Object.freeze({
  OL_EAGLE: 'EAGLE',
  OL_ROOSTER: 'ROOSTER',
  OL_BULL: 'BULL',
});

export const GRSpineAnimationsIds = Object.freeze({
  // Gift Race
  GR_SHOE: 'GR:SHOE',
  GR_BALLOON: 'GR:BALLOON',
  GR_SHIRT: 'GR:SHIRT',
  GR_FREEBETS_WON_X1: 'GR_FREEBETS_WON_X1',
  GR_FREEBETS_WON_X2: 'GR_FREEBETS_WON_X2',
  GR_FREEBETS_WON_X5: 'GR_FREEBETS_WON_X5',
  GR_FREEBETS_WON_X10: 'GR_FREEBETS_WON_X10',
  GR_FREEBETS_WON_X20: 'GR_FREEBETS_WON_X20',
  GR_START_FR: 'GR:START_FR',
  GR_START_EN: 'GR:START_EN',
  GR_START_DE: 'GR:START_DE',
  GR_START_ES: 'GR:START_ES',

  // Hunting All Stars
  GR_HUNTING_ALL_STARS_RABBIT_1: 'GR:HUNTING_ALL_STARS:RABBIT_1',
  GR_HUNTING_ALL_STARS_RABBIT_2: 'GR:HUNTING_ALL_STARS:RABBIT_2',
  GR_HUNTING_ALL_STARS_RABBIT_3: 'GR:HUNTING_ALL_STARS:RABBIT_3',
  GR_HUNTING_ALL_STARS_PASTILLE: 'GR:HUNTING_ALL_STARS:PASTILLE',
  GR_HUNTING_ALL_STARS_PASTILLE_LOOSE: 'GR:HUNTING_ALL_STARS:PASTILLE_LOOSE',
  GR_HUNTING_ALL_STARS_PASTILLE_DEFAULT: 'GR:HUNTING_ALL_STARS:PASTILLE_DEFAULT',
  GR_HUNTING_ALL_STARS_PASTILLE_WON: 'GR:HUNTING_ALL_STARS:PASTILLE_WON',
  GR_HUNTING_ALL_STARS_WELCOME: 'GR:HUNTING_ALL_STARS:WELCOME',
});

export const MPSpineAnimationsIds = Object.freeze({
  MP_WIN_FR_CARD_BROWN_1: 'MP:WIN_FR_CARD_BROWN_1',
  MP_WIN_FR_CARD_BROWN_2: 'MP:WIN_FR_CARD_BROWN_2',
  MP_WIN_FR_CARD_LIGHT_BLUE_1: 'MP:WIN_FR_CARD_LIGHT_BLUE_1',
  MP_WIN_FR_CARD_LIGHT_BLUE_2: 'MP:WIN_FR_CARD_LIGHT_BLUE_2',
  MP_WIN_FR_CARD_LIGHT_BLUE_3: 'MP:WIN_FR_CARD_LIGHT_BLUE_3',
  MP_WIN_FR_CARD_PURPLE_1: 'MP:WIN_FR_CARD_PURPLE_1',
  MP_WIN_FR_CARD_PURPLE_2: 'MP:WIN_FR_CARD_PURPLE_2',
  MP_WIN_FR_CARD_PURPLE_3: 'MP:WIN_FR_CARD_PURPLE_3',
  MP_WIN_FR_CARD_ORANGE_1: 'MP:WIN_FR_CARD_ORANGE_1',
  MP_WIN_FR_CARD_ORANGE_2: 'MP:WIN_FR_CARD_ORANGE_2',
  MP_WIN_FR_CARD_ORANGE_3: 'MP:WIN_FR_CARD_ORANGE_3',
  MP_WIN_FR_CARD_RED_1: 'MP:WIN_FR_CARD_RED_1',
  MP_WIN_FR_CARD_RED_2: 'MP:WIN_FR_CARD_RED_2',
  MP_WIN_FR_CARD_RED_3: 'MP:WIN_FR_CARD_RED_3',
  MP_WIN_FR_CARD_YELLOW_1: 'MP:WIN_FR_CARD_YELLOW_1',
  MP_WIN_FR_CARD_YELLOW_2: 'MP:WIN_FR_CARD_YELLOW_2',
  MP_WIN_FR_CARD_YELLOW_3: 'MP:WIN_FR_CARD_YELLOW_3',
  MP_WIN_FR_CARD_GREEN_1: 'MP:WIN_FR_CARD_GREEN_1',
  MP_WIN_FR_CARD_GREEN_2: 'MP:WIN_FR_CARD_GREEN_2',
  MP_WIN_FR_CARD_GREEN_3: 'MP:WIN_FR_CARD_GREEN_3',
  MP_WIN_FR_CARD_DARK_BLUE_1: 'MP:WIN_FR_CARD_DARK_BLUE_1',
  MP_WIN_FR_CARD_DARK_BLUE_2: 'MP:WIN_FR_CARD_DARK_BLUE_2',
  MP_WIN_FR_CARD_STATION_1: 'MP:WIN_FR_CARD_STATION_1',
  MP_WIN_FR_CARD_STATION_2: 'MP:WIN_FR_CARD_STATION_2',
  MP_WIN_FR_CARD_STATION_3: 'MP:WIN_FR_CARD_STATION_3',
  MP_WIN_FR_CARD_STATION_4: 'MP:WIN_FR_CARD_STATION_4',
  MP_WIN_FR_CARD_ENERGY_1: 'MP:WIN_FR_CARD_ENERGY_1',
  MP_WIN_FR_CARD_ENERGY_2: 'MP:WIN_FR_CARD_ENERGY_2',
  MP_WIN_FR_FAMILY_BROWN: 'MP:WIN_FR_FAMILY_BROWN',
  MP_WIN_FR_FAMILY_LIGHT_BLUE: 'MP:WIN_FR_FAMILY_LIGHT_BLUE',
  MP_WIN_FR_FAMILY_PURPLE: 'MP:WIN_FR_FAMILY_PURPLE',
  MP_WIN_FR_FAMILY_ORANGE: 'MP:WIN_FR_FAMILY_ORANGE',
  MP_WIN_FR_FAMILY_RED: 'MP:WIN_FR_FAMILY_RED',
  MP_WIN_FR_FAMILY_YELLOW: 'MP:WIN_FR_FAMILY_YELLOW',
  MP_WIN_FR_FAMILY_GREEN: 'MP:WIN_FR_FAMILY_GREEN',
  MP_WIN_FR_FAMILY_DARK_BLUE: 'MP:WIN_FR_FAMILY_DARK_BLUE',
  MP_WIN_FR_FAMILY_STATION: 'MP:WIN_FR_FAMILY_STATION',
  MP_WIN_FR_FAMILY_ENERGY: 'MP:WIN_FR_FAMILY_ENERGY',
  MP_WIN_ES_CARD_BROWN_1: 'MP:WIN_ES_CARD_BROWN_1',
  MP_WIN_ES_CARD_BROWN_2: 'MP:WIN_ES_CARD_BROWN_2',
  MP_WIN_ES_CARD_LIGHT_BLUE_1: 'MP:WIN_ES_CARD_LIGHT_BLUE_1',
  MP_WIN_ES_CARD_LIGHT_BLUE_2: 'MP:WIN_ES_CARD_LIGHT_BLUE_2',
  MP_WIN_ES_CARD_LIGHT_BLUE_3: 'MP:WIN_ES_CARD_LIGHT_BLUE_3',
  MP_WIN_ES_CARD_PURPLE_1: 'MP:WIN_ES_CARD_PURPLE_1',
  MP_WIN_ES_CARD_PURPLE_2: 'MP:WIN_ES_CARD_PURPLE_2',
  MP_WIN_ES_CARD_PURPLE_3: 'MP:WIN_ES_CARD_PURPLE_3',
  MP_WIN_ES_CARD_ORANGE_1: 'MP:WIN_ES_CARD_ORANGE_1',
  MP_WIN_ES_CARD_ORANGE_2: 'MP:WIN_ES_CARD_ORANGE_2',
  MP_WIN_ES_CARD_ORANGE_3: 'MP:WIN_ES_CARD_ORANGE_3',
  MP_WIN_ES_CARD_RED_1: 'MP:WIN_ES_CARD_RED_1',
  MP_WIN_ES_CARD_RED_2: 'MP:WIN_ES_CARD_RED_2',
  MP_WIN_ES_CARD_RED_3: 'MP:WIN_ES_CARD_RED_3',
  MP_WIN_ES_CARD_YELLOW_1: 'MP:WIN_ES_CARD_YELLOW_1',
  MP_WIN_ES_CARD_YELLOW_2: 'MP:WIN_ES_CARD_YELLOW_2',
  MP_WIN_ES_CARD_YELLOW_3: 'MP:WIN_ES_CARD_YELLOW_3',
  MP_WIN_ES_CARD_GREEN_1: 'MP:WIN_ES_CARD_GREEN_1',
  MP_WIN_ES_CARD_GREEN_2: 'MP:WIN_ES_CARD_GREEN_2',
  MP_WIN_ES_CARD_GREEN_3: 'MP:WIN_ES_CARD_GREEN_3',
  MP_WIN_ES_CARD_DARK_BLUE_1: 'MP:WIN_ES_CARD_DARK_BLUE_1',
  MP_WIN_ES_CARD_DARK_BLUE_2: 'MP:WIN_ES_CARD_DARK_BLUE_2',
  MP_WIN_ES_CARD_STATION_1: 'MP:WIN_ES_CARD_STATION_1',
  MP_WIN_ES_CARD_STATION_2: 'MP:WIN_ES_CARD_STATION_2',
  MP_WIN_ES_CARD_STATION_3: 'MP:WIN_ES_CARD_STATION_3',
  MP_WIN_ES_CARD_STATION_4: 'MP:WIN_ES_CARD_STATION_4',
  MP_WIN_ES_CARD_ENERGY_1: 'MP:WIN_ES_CARD_ENERGY_1',
  MP_WIN_ES_CARD_ENERGY_2: 'MP:WIN_ES_CARD_ENERGY_2',
  MP_WIN_ES_FAMILY_BROWN: 'MP:WIN_ES_FAMILY_BROWN',
  MP_WIN_ES_FAMILY_LIGHT_BLUE: 'MP:WIN_ES_FAMILY_LIGHT_BLUE',
  MP_WIN_ES_FAMILY_PURPLE: 'MP:WIN_ES_FAMILY_PURPLE',
  MP_WIN_ES_FAMILY_ORANGE: 'MP:WIN_ES_FAMILY_ORANGE',
  MP_WIN_ES_FAMILY_RED: 'MP:WIN_ES_FAMILY_RED',
  MP_WIN_ES_FAMILY_YELLOW: 'MP:WIN_ES_FAMILY_YELLOW',
  MP_WIN_ES_FAMILY_GREEN: 'MP:WIN_ES_FAMILY_GREEN',
  MP_WIN_ES_FAMILY_DARK_BLUE: 'MP:WIN_ES_FAMILY_DARK_BLUE',
  MP_WIN_ES_FAMILY_STATION: 'MP:WIN_ES_FAMILY_STATION',
  MP_WIN_ES_FAMILY_ENERGY: 'MP:WIN_ES_FAMILY_ENERGY',
  MP_WIN_DE_CARD_BROWN_1: 'MP:WIN_DE_CARD_BROWN_1',
  MP_WIN_DE_CARD_BROWN_2: 'MP:WIN_DE_CARD_BROWN_2',
  MP_WIN_DE_CARD_LIGHT_BLUE_1: 'MP:WIN_DE_CARD_LIGHT_BLUE_1',
  MP_WIN_DE_CARD_LIGHT_BLUE_2: 'MP:WIN_DE_CARD_LIGHT_BLUE_2',
  MP_WIN_DE_CARD_LIGHT_BLUE_3: 'MP:WIN_DE_CARD_LIGHT_BLUE_3',
  MP_WIN_DE_CARD_PURPLE_1: 'MP:WIN_DE_CARD_PURPLE_1',
  MP_WIN_DE_CARD_PURPLE_2: 'MP:WIN_DE_CARD_PURPLE_2',
  MP_WIN_DE_CARD_PURPLE_3: 'MP:WIN_DE_CARD_PURPLE_3',
  MP_WIN_DE_CARD_ORANGE_1: 'MP:WIN_DE_CARD_ORANGE_1',
  MP_WIN_DE_CARD_ORANGE_2: 'MP:WIN_DE_CARD_ORANGE_2',
  MP_WIN_DE_CARD_ORANGE_3: 'MP:WIN_DE_CARD_ORANGE_3',
  MP_WIN_DE_CARD_RED_1: 'MP:WIN_DE_CARD_RED_1',
  MP_WIN_DE_CARD_RED_2: 'MP:WIN_DE_CARD_RED_2',
  MP_WIN_DE_CARD_RED_3: 'MP:WIN_DE_CARD_RED_3',
  MP_WIN_DE_CARD_YELLOW_1: 'MP:WIN_DE_CARD_YELLOW_1',
  MP_WIN_DE_CARD_YELLOW_2: 'MP:WIN_DE_CARD_YELLOW_2',
  MP_WIN_DE_CARD_YELLOW_3: 'MP:WIN_DE_CARD_YELLOW_3',
  MP_WIN_DE_CARD_GREEN_1: 'MP:WIN_DE_CARD_GREEN_1',
  MP_WIN_DE_CARD_GREEN_2: 'MP:WIN_DE_CARD_GREEN_2',
  MP_WIN_DE_CARD_GREEN_3: 'MP:WIN_DE_CARD_GREEN_3',
  MP_WIN_DE_CARD_DARK_BLUE_1: 'MP:WIN_DE_CARD_DARK_BLUE_1',
  MP_WIN_DE_CARD_DARK_BLUE_2: 'MP:WIN_DE_CARD_DARK_BLUE_2',
  MP_WIN_DE_CARD_STATION_1: 'MP:WIN_DE_CARD_STATION_1',
  MP_WIN_DE_CARD_STATION_2: 'MP:WIN_DE_CARD_STATION_2',
  MP_WIN_DE_CARD_STATION_3: 'MP:WIN_DE_CARD_STATION_3',
  MP_WIN_DE_CARD_STATION_4: 'MP:WIN_DE_CARD_STATION_4',
  MP_WIN_DE_CARD_ENERGY_1: 'MP:WIN_DE_CARD_ENERGY_1',
  MP_WIN_DE_CARD_ENERGY_2: 'MP:WIN_DE_CARD_ENERGY_2',
  MP_WIN_DE_FAMILY_BROWN: 'MP:WIN_DE_FAMILY_BROWN',
  MP_WIN_DE_FAMILY_LIGHT_BLUE: 'MP:WIN_DE_FAMILY_LIGHT_BLUE',
  MP_WIN_DE_FAMILY_PURPLE: 'MP:WIN_DE_FAMILY_PURPLE',
  MP_WIN_DE_FAMILY_ORANGE: 'MP:WIN_DE_FAMILY_ORANGE',
  MP_WIN_DE_FAMILY_RED: 'MP:WIN_DE_FAMILY_RED',
  MP_WIN_DE_FAMILY_YELLOW: 'MP:WIN_DE_FAMILY_YELLOW',
  MP_WIN_DE_FAMILY_GREEN: 'MP:WIN_DE_FAMILY_GREEN',
  MP_WIN_DE_FAMILY_DARK_BLUE: 'MP:WIN_DE_FAMILY_DARK_BLUE',
  MP_WIN_DE_FAMILY_STATION: 'MP:WIN_DE_FAMILY_STATION',
  MP_WIN_DE_FAMILY_ENERGY: 'MP:WIN_DE_FAMILY_ENERGY',
});

export const BoomSpineAnimationsIds = Object.freeze({
  // HALLOWEEN
  BOOM_HALLOWEEN_EXPLOSION: 'BOOM:HALLOWEEN_EXPLOSION',
  // VALENTINE
  BOOM_VALENTINE_IDLE: 'BOOM:VALENTINE_IDLE',
  BOOM_VALENTINE_IDLE_STEP_1: 'BOOM:VALENTINE_IDLE_STEP_1',
  BOOM_VALENTINE_IDLE_STEP_2: 'BOOM:VALENTINE_IDLE_STEP_2',
  BOOM_VALENTINE_IDLE_STEP_3: 'BOOM:VALENTINE_IDLE_STEP_3',
  BOOM_VALENTINE_IDLE_STEP_4: 'BOOM:VALENTINE_IDLE_STEP_4',
  BOOM_VALENTINE_IDLE_STEP_5: 'BOOM:VALENTINE_IDLE_STEP_5',
  BOOM_VALENTINE_START_DE: 'BOOM:VALENTINE_START_DE',
  BOOM_VALENTINE_START_EN: 'BOOM:VALENTINE_START_EN',
  BOOM_VALENTINE_START_ES: 'BOOM:VALENTINE_START_ES',
  BOOM_VALENTINE_START_FR: 'BOOM:VALENTINE_START_FR',
  BOOM_VALENTINE_EXPLOSION: 'BOOM:VALENTINE_EXPLOSION',
  // ST PATRICK
  BOOM_PATRICK_IDLE: 'BOOM:PATRICK_IDLE',
  BOOM_PATRICK_IDLE_STEP_1: 'BOOM:PATRICK_IDLE_STEP_1',
  BOOM_PATRICK_IDLE_STEP_2: 'BOOM:PATRICK_IDLE_STEP_2',
  BOOM_PATRICK_IDLE_STEP_3: 'BOOM:PATRICK_IDLE_STEP_3',
  BOOM_PATRICK_IDLE_STEP_4: 'BOOM:PATRICK_IDLE_STEP_4',
  BOOM_PATRICK_IDLE_STEP_5: 'BOOM:PATRICK_IDLE_STEP_5',
  BOOM_PATRICK_START: 'BOOM:PATRICK_START',
  BOOM_PATRICK_EXPLOSION: 'BOOM:PATRICK_EXPLOSION',
});

export const SpineAnimationIds = Object.freeze({
  ...GeneralSpineAnimationsIds,
  ...KLSpineAnimationIds,
  ...BetBuilderSpineAnimationIds,
  ...WinModalSpineAnimationIds,
  ...BetShareSpineAnimationIds,
  ...OverlaySpineAnimationsIds,
  ...GRSpineAnimationsIds,
  ...MPSpineAnimationsIds,
  ...BoomSpineAnimationsIds,
});
export type SpineAnimationId = ObjectValuesUnionType<typeof SpineAnimationIds>;
